import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import commonData from './commonData/reducers';
import employee from './employee/index';
import authentication from './authentication/reducers';

export default combineReducers({
    routing: routerReducer,
    commonData: commonData,
    employee: employee,
    authentication: authentication
});



// WEBPACK FOOTER //
// ./src/services/redux/index.js